import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { discountReasonsService } from '@/services/discountReasons';

export function useDiscountReasons(onlyActive = true) {
  return useQuery({
    queryKey: ['discount-reasons', onlyActive],
    queryFn: () => discountReasonsService.list(onlyActive),
  });
}

export function useCreateDiscountReason() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => discountReasonsService.create(name),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['discount-reasons'] }),
  });
}

export function useUpdateDiscountReason() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...cambios }: { id: number; name?: string; is_active?: boolean }) =>
      discountReasonsService.update(id, cambios),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['discount-reasons'] }),
  });
}

export function useDeleteDiscountReason() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => discountReasonsService.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['discount-reasons'] }),
  });
}
